import styled from 'styled-components/macro';
import { Button } from 'ui-component-library/components';

import { FlexColumn, FlexJustifyAround, FlexJustifyCenter } from '../../../../../shared-styles/flex';

export const Container = styled.div`
  ${FlexColumn}
  padding: ${({ theme }) => theme.spacing(10)} 0;
`;

export const TextContainer = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  margin-bottom: ${({ theme }) => theme.spacing(20)};
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  ${FlexJustifyAround}
`;

export const CancelButton = styled(Button)`
  font-size: 12px;
`;

export const ConfirmButton = styled(Button)`
  && {
    font-size: 12px;
    padding: ${({ theme }) => theme.spacing(10)} 40px;
  }
`;

export const LoadingContainer = styled.div`
  ${FlexJustifyCenter}
`;
